import { Coord, GridConfig, SelectBoxConfig, SelectBoxItem, SwitcherButtonStyle, TopSwitcherOptions } from "../../../../../src/types/Interface";

export const ASSETS = []
export const TIMER_COORD = { x: -250, y: 50 };
export const QUESTION_COUNT = 20;
export const TSwtButEventBusNames = {
  rotBut: "ROTATION_BUTTON",
  dirBut: "DIRECTION_BUTTON",
  questTypeBut: "QUESTION_TOP_SWITCHER"
}

export const GRID_CONFIG: GridConfig = {
  x: 450,
  y: 460,
  width: 720,
  height: 720,
  cellSize: 48,
  lineWidth: 2,
  lineColor: 0x959595
};

export const DrawToolsSelectBoxCnfg: SelectBoxConfig = {
  x: 0,
  y: 140,
  width: 560,
  height: 60,
  fillColor: 0x0195b8,
  childFillColor: 0x30c3e6,
  color: 0x00FF00
}

export const SheetSelectBoxCnfg: SelectBoxConfig = {
  header: "Select Sheet",
  x: 0,
  y: 380,
  width: 540,
  height: 60,
  fillColor: 0x0195b8,
  childFillColor: 0x30c3e6,
  color: 0x00FF00
}

export const PractiseSwitcherButtonStyles: { [key: string]: SwitcherButtonStyle } = {
  gotoTestMode: {
    x: 135,
    y: 50,
    width: 240,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xDDDDDD,
    fontSize: 28
  },
  genRandomlyQuestion: {
    x: 0,
    y: 230,
    width: 450,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  },
  tracingPaper: {
    x: -140,
    y: 460,
    width: 250,
    height: 60,
    pressedBgColor: 0xFFFFFF
  },
  animate: {
    x: -140,
    y: 540,
    width: 250,
    height: 60,
    pressedBgColor: 0xFFFFFF
  },
  showSolution: {
    x: 140,
    y: 460,
    width: 250,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF
  },
  hint: {
    x: 140,
    y: 540,
    width: 250,
    height: 60,
    pressedBgColor: 0xFFFFFF
  }
};

export const PractiseModeQuestionCbConfig = {
  TYPE1: {
    coord: {
      x: -220,
      y: 290,
    },
    label: "Type1 - Draw",
    color: 0xdd45d0,
  },
  TYPE2: {
    coord: {
      x: 10,
      y: 290,
    },
    label: "Type2 - Specify",
    color: 0xdd45d0,
  },
}

export const TestTopSwicherButtonStyles: { [key: string]: { coord: Coord, opts: TopSwitcherOptions } } = {
  directionButton: {
    coord: {
      x: -100,
      y: 390,
    },
    opts: {
      fontSize: 24,
      buttonColor: 0x66FF99,
      buttonHeight: 48,
      borderStyle: {
        width: 3,
        color: 0x232323
      }
    }
  },
  rotationButton: {
    coord: {
      x: -90,
      y: 310,
    },
    opts: {
      fontSize: 24,
      buttonColor: 0x66FF99,
      buttonHeight: 48,
      borderStyle: {
        width: 3,
        color: 0x232323
      }
    }
  }
}

export const TestSwitcherButtonStyles: { [key: string]: SwitcherButtonStyle } = {
  gotoPractiseMode: {
    x: 135,
    y: 50,
    width: 280,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xDDDDDD,
    fontSize: 28
  },
  nextQuestion: {
    x: 0,
    y: 470,
    width: 450,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  },
  giveAnswer: {
    x: -120,
    y: 470,
    width: 210,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  },
  saveAnswer: {
    x: 120,
    y: 470,
    width: 210,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  },
  goToPractise: {
    x: -120,
    y: 470,
    width: 210,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  },
  tryAgain: {
    x: 120,
    y: 470,
    width: 210,
    height: 60,
    defaultBgColor: 0x66FF99,
    pressedBgColor: 0xFFFFFF,
    fontSize: 28
  }
}

export const DrawToolsSlctBxItemList: SelectBoxItem[] = [
  { label: "Translation", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Reflection 1", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Reflection 2", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Rotation", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Enlargement 1", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Enlargement 2", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Enlargement- Fractional", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Enlargement - Negative", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Describing Transformations", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Mixed Transformations 1", onHandle: () => { console.log("bu select box item ı") } },
  { label: "Mixed Transformations 2", onHandle: () => { console.log("bu select box item ı") } }
]

export const SheetSelectBoxItemList: SelectBoxItem[] = [
  { label: "Open Worksheet", onHandle: () => { console.log("Open worksheet") } },
  { label: "Open Worksheet Solution", onHandle: () => { console.log("pen worksheet solution") } },
  { label: "Open Cheatsheet", onHandle: () => { console.log("Open Cheatsheet") } },
  { label: "Open Past Paper Question", onHandle: () => { console.log("Open Past paper Question") } }
]